<template>
  <el-drawer v-model="showSettings" :withHeader="false" direction="rtl" size="300px">
    <div class="p-4 h-full flex flex-col">
      <h3 class="text-base font-bold text-gray-900 mb-5"  v-if="false">主题风格设置</h3>

      <div class="flex justify-between gap-4 mb-6"  v-if="false">
        <div 
          class="relative flex-1 cursor-pointer rounded-lg border-2 transition-all duration-300 overflow-hidden group"
          :class="sideTheme === 'theme-dark' ? 'border-blue-500 shadow-md' : 'border-gray-200 hover:border-gray-300'"
          @click="handleTheme('theme-dark')"
        >
          <img src="@/assets/images/dark.svg" alt="dark" class="block w-full h-auto bg-gray-900" />
          <div 
            v-if="sideTheme === 'theme-dark'" 
            class="absolute inset-0 flex items-center justify-center bg-blue-500/20 text-blue-500"
          >
            <i class="text-xl font-bold">
              <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"/>
              </svg>
            </i>
          </div>
        </div>

        <div 
          class="relative flex-1 cursor-pointer rounded-lg border-2 transition-all duration-300 overflow-hidden group"
          :class="sideTheme === 'theme-light' ? 'border-blue-500 shadow-md' : 'border-gray-200 hover:border-gray-300'"
          @click="handleTheme('theme-light')"
        >
          <img src="@/assets/images/light.svg" alt="light" class="block w-full h-auto bg-gray-100" />
          <div 
            v-if="sideTheme === 'theme-light'" 
            class="absolute inset-0 flex items-center justify-center bg-blue-500/20 text-blue-500"
          >
            <i class="text-xl font-bold">
              <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"/>
              </svg>
            </i>
          </div>
        </div>
      </div>

      <!-- 主题颜色模块：保留代码，但通过 v-if 隐藏，不对用户展示 -->
      <div v-if="false" class="flex items-center justify-between mb-6">
        <span class="text-sm text-gray-600 font-medium">主题颜色</span>
        <el-color-picker v-model="theme" :predefine="predefineColors" @change="themeChange" />
      </div>

      <div class="h-px bg-gray-100 my-4"></div>

      <h3 class="text-base font-bold text-gray-900 mb-5 mt-2">系统布局配置</h3>
      
      <div class="space-y-4 flex-1">
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">开启 TopNav</span>
          <el-switch v-model="topNav" />
        </div>

        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">开启 Tags-Views</span>
          <el-switch v-model="tagsView" />
        </div>

        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">固定 Header</span>
          <el-switch v-model="fixedHeader" />
        </div>

        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">显示 Logo</span>
          <el-switch v-model="sidebarLogo" />
        </div>

        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">动态标题</span>
          <el-switch v-model="dynamicTitle" />
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-3">
        <el-button type="primary" plain icon="DocumentAdd" class="!w-full !ml-0" @click="saveSetting">
          保存配置
        </el-button>
        <el-button plain icon="Refresh" class="!w-full !ml-0" @click="resetSetting">
          重置配置
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
import variables from '@/assets/styles/variables.module.scss'
// import originElementPlus from 'element-plus/theme-chalk/index.css'
import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
import { useDynamicTitle } from '@/utils/dynamicTitle'
import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'
import { handleThemeStyle } from '@/utils/theme'

const { proxy } = getCurrentInstance()
const appStore = useAppStore()
const settingsStore = useSettingsStore()
const permissionStore = usePermissionStore()
const showSettings = ref(false)
const theme = ref(settingsStore.theme)
const sideTheme = ref(settingsStore.sideTheme)
const storeSettings = computed(() => settingsStore)
const predefineColors = ref(['#409EFF', '#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585'])

/** 是否需要topnav */
const topNav = computed({
  get: () => storeSettings.value.topNav,
  set: (val) => {
    settingsStore.changeSetting({ key: 'topNav', value: val })
    if (!val) {
      appStore.toggleSideBarHide(false)
      permissionStore.setSidebarRouters(permissionStore.defaultRoutes)
    }
  },
})
/** 是否需要tagview */
const tagsView = computed({
  get: () => storeSettings.value.tagsView,
  set: (val) => {
    settingsStore.changeSetting({ key: 'tagsView', value: val })
  },
})
/**是否需要固定头部 */
const fixedHeader = computed({
  get: () => storeSettings.value.fixedHeader,
  set: (val) => {
    settingsStore.changeSetting({ key: 'fixedHeader', value: val })
  },
})
/**是否需要侧边栏的logo */
const sidebarLogo = computed({
  get: () => storeSettings.value.sidebarLogo,
  set: (val) => {
    settingsStore.changeSetting({ key: 'sidebarLogo', value: val })
  },
})
/**是否需要侧边栏的动态网页的title */
const dynamicTitle = computed({
  get: () => storeSettings.value.dynamicTitle,
  set: (val) => {
    settingsStore.changeSetting({ key: 'dynamicTitle', value: val })
    // 动态设置网页标题
    useDynamicTitle()
  },
})

function themeChange(val) {
  // 主题色已固定为 #409eff，不再允许在界面中修改
}
function handleTheme(val) {
  settingsStore.changeSetting({ key: 'sideTheme', value: val })
  sideTheme.value = val
}
function saveSetting() {
  proxy.$modal.loading('正在保存到本地，请稍候...')
  let layoutSetting = {
    topNav: storeSettings.value.topNav,
    tagsView: storeSettings.value.tagsView,
    fixedHeader: storeSettings.value.fixedHeader,
    sidebarLogo: storeSettings.value.sidebarLogo,
    dynamicTitle: storeSettings.value.dynamicTitle,
    sideTheme: storeSettings.value.sideTheme,
  }
  localStorage.setItem('layout-setting', JSON.stringify(layoutSetting))
  setTimeout(proxy.$modal.closeLoading(), 1000)
}
function resetSetting() {
  proxy.$modal.loading('正在清除设置缓存并刷新，请稍候...')
  localStorage.removeItem('layout-setting')
  setTimeout('window.location.reload()', 1000)
}
function openSetting() {
  showSettings.value = true
}

defineExpose({
  openSetting,
})
</script>

<style lang="scss" scoped>
.setting-drawer-title {
  margin-bottom: 12px;
  color: rgb(0 0 0 / 85%);
  font-weight: bold;
  line-height: 22px;

  .drawer-title {
    font-size: 14px;
  }
}

.setting-drawer-block-checbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  margin-bottom: 20px;

  .setting-drawer-block-checbox-item {
    position: relative;
    margin-right: 16px;
    border-radius: 2px;
    cursor: pointer;

    img {
      width: 48px;
      height: 48px;
    }

    .custom-img {
      width: 48px;
      height: 38px;
      border-radius: 5px;
      box-shadow: 1px 1px 2px #898484;
    }

    .setting-drawer-block-checbox-selectIcon {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      padding-top: 15px;
      padding-left: 24px;
      color: #1890ff;
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.drawer-item {
  padding: 12px 0;
  color: rgb(0 0 0 / 65%);
  font-size: 14px;

  .comp-style {
    margin: -3px 8px 0 0;
    float: right;
  }
}
</style>
